<template>
  <div class="case-details">
    <Form ref="form" :form-data="formData" :default-values="fieldValues">
    </Form>
  </div>
</template>

<script>
//constants
import { caseDetailsForm } from "@/config/caseInformationConstant.js";

export default {
  name: "DisputeCaseDetails",
  props: {
    caseDetailsSfdc: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: caseDetailsForm() || [],
      fieldValues: {},
    };
  },
  created() {
    const formFields = this.formData.map((form) => form.formFields);
    [].concat.apply([], formFields).forEach((el) => {
      this.fieldValues[el.name] =
        typeof this.caseDetailsSfdc[el.name] !== "undefined"
          ? this.caseDetailsSfdc[el.name]
          : "-";
    });
  },
};
</script>

<style lang="scss">
.case-details .form-input__field:disabled {
  color: var(--Gray-900);
}
</style>
